import { PlusIcon } from '@heroicons/react/20/solid';
import { FaceSmileIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import type { MouseEventHandler } from 'react';
import { twMerge } from 'tailwind-merge';

export const VALID_EMOJIS = ['👍', '👎', '❤', '🔥', '🤣', '😭'];

// Desktop hover affordance only. On touch there is no hover, so the reaction row
// is opened by a long-press on the message instead (see DM.tsx / useLongPress);
// this component is hidden there rather than forced always-open (#1547).
const AddReactionButton = ({
  isLeftAlign,
  onClick,
  embedded,
}: {
  isLeftAlign: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  // When rendered inside the shared hover toolbar (#1724) the surrounding box
  // supplies the border/background/divider, so drop this button's own pill
  // chrome and let it read as a plain toolbar segment.
  embedded?: boolean;
}) => {
  return (
    <button
      className={twMerge(
        'group/reactions flex flex-row items-center rounded-sm bg-white px-2 py-px shadow-sm ring-1 ring-zinc-900/10 transition-transform duration-300 ease-in-out hover:gap-1 dark:bg-zinc-900 dark:shadow-none dark:shadow-white/5 dark:ring-white/10',
        isLeftAlign && 'rounded-full',
        embedded &&
          'rounded-none bg-transparent shadow-none ring-0 dark:bg-transparent dark:ring-0',
      )}
    >
      {VALID_EMOJIS.map((validEmoji) => (
        <span
          key={validEmoji}
          className="hidden rounded-sm px-1 grayscale hover:bg-zinc-900/5 hover:grayscale-0 group-hover/reactions:block dark:hover:bg-white/5"
          onClick={onClick}
          data-emoji={validEmoji}
        >
          {validEmoji}
        </span>
      ))}

      <div
        className={clsx(
          'flex flex-row items-start -space-x-2 py-[2px]',
          isLeftAlign && 'order-first',
        )}
      >
        <FaceSmileIcon
          height={20}
          className="size-5 shrink-0 text-zinc-500 dark:text-zinc-400"
          aria-hidden="true"
        />
        <div className="size-3 rounded-full bg-white dark:bg-zinc-900">
          <PlusIcon
            height={12}
            className="size-3 shrink-0 stroke-1 text-zinc-500 dark:text-zinc-400"
            aria-hidden="true"
          />
        </div>
      </div>
    </button>
  );
};

export default AddReactionButton;
